const pageId = '251101';

export default {
  pageName: 'Weekly Report Overview',
  pageId,
  pagePath: '/opinion/CustomizedReports/WeeklyReport/Overview',
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  }, 
};
